module.exports = __webpack_public_path__ + "media/parents/applying-to-college-5bde4730.svg";